import React from 'react'
import { Bold } from './styles'

export const AUTH_STEP_TITLE = 'Authenticate with Leat'

export const AUTH_STEP_DESCRIPTION =
  'Paste the personal access token from your Leat dashboard under Auth. We use it to read your shops, sync your menu and keep loyalty balances up to date.'

export const TOKEN_STORAGE_HINT =
  'Stored encrypted. Revoke it in Leat at any time and this integration stops immediately.'

export const EXTERNAL_LINK_PROPS = {
  target: '_blank',
  rel: 'noopener noreferrer'
} as const

export const LINK_STORES_STEP_TITLE = 'Link your stores'

export const LINK_STORES_STEP_DESCRIPTION =
  'Choose which Leat shop each Slerp store belongs to. The integration will only work for stores that are mapped between Slerp and Leat.'

export const PUSH_ORDERS_TITLE = 'Push order to Leat'

export const PUSH_ORDERS_COLUMN_HEADER = 'Push Order to Leat'

export const PUSH_ORDERS_DESCRIPTION = (
  <>
    Turn a store&apos;s toggle off in the table below <Bold>ONLY</Bold> if that
    store&apos;s Slerp orders already reach Leat through another integration,
    such as your POS or middleware, to avoid duplication.
  </>
)

export const LOYALTY_CONSENT_DESCRIPTION_SLERP =
  "You're currently using Slerp's built-in loyalty. Connecting Leat means your Slerp Loyalty Program will pause. Existing Slerp stamps and points stay visible to customers but stop accruing. Once connected, Leat will be your only loyalty engine."

export const marketingConsentLabel = (customerCount: number) => (
  <>
    Share my <Bold>{customerCount.toLocaleString()} customers</Bold> with Leat
    so their loyalty history carries across from day one. You can stop sharing
    at any time.
  </>
)

export const linkedSummary = (
  linkedCount: number,
  totalCount: number,
  pushDisabledCount: number
): string => {
  const base = `${linkedCount} of ${totalCount} stores linked`
  if (pushDisabledCount === 0) return base
  const noun = pushDisabledCount === 1 ? 'store' : 'stores'
  const verb = pushDisabledCount === 1 ? 'its' : 'their'
  return `${base} · ${pushDisabledCount} ${noun} will stay on ${verb} current setup`
}

// customerCount is every merchant customer (GET_CUSTOMER_COUNT), the same
// figure the connect form's consent checkbox shows.
export const storesSavedMessage = (
  linkedCount: number,
  totalCount: number,
  customerCount: number | null
): string => {
  const noun = linkedCount === 1 ? 'Store' : 'Stores'
  const base = `${linkedCount} ${noun} linked to Leat — ${linkedCount} of ${totalCount} connected`
  if (customerCount === null) return `${base}.`
  const customers = customerCount === 1 ? 'customer' : 'customers'
  return `${base}, loyalty history carried across for ${customerCount.toLocaleString()} ${customers}.`
}
